import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../../localization'
import { LastChangerType } from '../../../../types/bookingDetails'
import { useStyles } from './styles/index.styles'

type Props = {
  data: LastChangerType | undefined
}

const LastChanger = ({ data }: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Last Changer')}
        </Typography>
      </div>
      <div className={classes.divider} />
      <div className={classes.bottom}>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Name')}
          </Typography>
          <Typography variant="h5" className={classes.text}>
            {data?.name}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Email')}
          </Typography>
          <Typography variant="h5" className={classes.text}>
            {data?.email}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('IP')}
          </Typography>
          <Typography variant="h5" className={classes.text}>
            {data?.ip}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default LastChanger
